import { PageDisplayOption, pageDisplayOptions } from '../../types/pageDispalyOptions.ts';


interface Props {
    pageDisplay: PageDisplayOption | undefined;
    setPageDisplay: (option: PageDisplayOption) => void;
}

export function PageDisplaySettings({
    pageDisplay,
    setPageDisplay,
}: Props) {


    const handleDisplayChange = (displayKey: string) => {
        const display = pageDisplayOptions.find(option => option.key === displayKey);
        if (!display) return;
        setPageDisplay(display);
    }

    return (
        <div className='flex--horz'>
            <label htmlFor='display'>Display</label>
            <select
                id='display'
                value={pageDisplay?.key}
                onChange={(e) => handleDisplayChange(e.target.value)}
            >
                {pageDisplayOptions.map(option =>
                    <option key={option.key} value={option.key}>
                        {option.label}
                    </option>
                )}
            </select>
        </div>
    );
}
